import React, { FC } from 'react'

import { getChristmasOpeningHoursBanner } from '@smarty-nx/contentful'
import { Typography } from '@smarty-nx/ds'
import ReactMarkdown, { Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'

import classes from './christmas-opening-hours.module.scss'
import Card from '../Card'

const bannerData = getChristmasOpeningHoursBanner()

const markdownComponents: Components = {
  p({ node: _, ...props }) {
    return <p className={classes.description} {...props} />
  },
  table({ node: _, ...props }) {
    return <table className={classes.hoursTable} {...props} />
  },
  a({ node: _, children, ...props }) {
    return (
      <a target="_blank" rel="noopener noreferrer" {...props}>
        {children}
      </a>
    )
  },
}

export const ChristmasOpeningHours: FC = () => {
  if (!bannerData) {
    return null
  }

  return (
    <Card className={classes.darkCard}>
      <Typography
        component="h2"
        variant="Kollektif/ExtraLarge"
        className={classes.heading}
        data-testid="christmas-opening-title"
      >
        {bannerData.title}
      </Typography>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={markdownComponents}
      >
        {bannerData.description || ''}
      </ReactMarkdown>
    </Card>
  )
}
